export function Logo({ className = "", height = "h-12" }) {
  return (
    <img
      src="/raphadon-logo.png"
      alt="Raphadon Global Healthcare"
      className={`${height} w-auto object-contain ${className}`}
    />
  );
}

export function StatusBadge({ status }) {
  const map = {
    optimal: { label: "Optimal", cls: "bg-success/10 text-success border-success/30" },
    low: { label: "Low Stock", cls: "bg-warning/10 text-warning border-warning/40" },
    out: { label: "Out of Stock", cls: "bg-destructive/10 text-destructive border-destructive/40" },
  };
  const s = map[status] || map.optimal;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-sm border text-xs font-medium ${s.cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {s.label}
    </span>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 border-b border-border px-6 md:px-8 py-6 bg-card">
      <div>
        <h1 className="text-2xl md:text-3xl font-heading font-semibold tracking-tight text-foreground">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-3">{children}</div>}
    </div>
  );
}
